import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      key: 'design',
      title: t('designTitle'),
      desc: t('designDesc'),
    },
    {
      key: 'construct',
      title: t('constructTitle'),
      desc: t('constructDesc'),
    },
    {
      key: 'maintain',
      title: t('maintainTitle'),
      desc: t('maintainDesc'),
    },
  ];

  return (
    <div className="min-h-screen pt-24 px-6 text-center">
      <Helmet>
        <title>Infinity Energy Solar – Services</title>
      </Helmet>
      <h1 className="text-3xl font-bold text-[#173861] mb-4">{t('servicesHero')}</h1>
      <p className="text-lg max-w-3xl mx-auto text-[#173861] mb-10">{t('servicesIntro')}</p>

      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-3 max-w-6xl mx-auto px-4">
        {services.map((service, index) => (
          <div
            key={service.key}
            className="group relative overflow-hidden rounded-xl bg-white shadow-md border border-green-600 transition duration-300"
          >
            <div className="p-6 flex flex-col justify-between h-full">
              <h2 className="text-xl font-bold text-[#173861] mb-2 transition-opacity duration-300 group-hover:opacity-80">
                {service.title}
              </h2>
              <p className="text-[#173861] text-base transition-opacity duration-300 group-hover:opacity-90">
                {service.desc}
              </p>
            </div>
            <div className="absolute bottom-0 left-0 w-full h-2 bg-green-600"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
